const useShouldShowTapToPay = (provider?: string) => {
  const isIOS = /iPhone/.test(navigator.userAgent);
  const isWebView = !!window.ReactNativeWebView;
  const isStripe = provider === 'stripe';

  return isIOS && isWebView && isStripe;
};

export default useShouldShowTapToPay;
